import { render, staticRenderFns } from "./topicDetail.vue?vue&type=template&id=a1b89ec0&scoped=true&"
import script from "./topicDetail.vue?vue&type=script&lang=js&"
export * from "./topicDetail.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/newTopic/interviewDetail.less?vue&type=style&index=0&id=a1b89ec0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b89ec0",
  null
  
)

component.options.__file = "topicDetail.vue"
export default component.exports